export default __webpack_public_path__ + "static/media/env-icon.80e6aec6.svg";